module.exports = __webpack_public_path__ + "img/img_gross_floor_area.16eaa435.png";